module.exports = "h6 {\r\n    font-size: 18px;\r\n}\r\np {\r\n    font-size: 16px;\r\n    text-align: justify;\r\n}\r\n.inside-content{\r\n    padding: 15px 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Main/about-us-page/about-us-page.component.css
// module id = ./src/app/pages/Main/about-us-page/about-us-page.component.css
// module chunks = main